<script lang="ts" setup>
import { i18n } from '@/lib'

withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg'
    fullScreen?: boolean
  }>(),
  {
    size: 'lg',
    fullScreen: false,
  },
)
</script>

<template>
  <div
    class="flex sticky inset-x-0 top-0 z-10 justify-center items-center"
    :class="{
      'h-full bg-white/60 dark:bg-gray-950/60': fullScreen,
      'h-[400px]': !fullScreen,
    }"
  >
    <span class="sr-only">{{ i18n('Loading...') }}</span>
    <span
      class="inline-block w-12 h-12 rounded-full loader border-primary-200 dark:border-gray-700 border-b-primary-500 dark:border-b-primary-500"
      :class="size"
    />
  </div>
</template>

<style>
.loader {
  animation: rotation 0.5s linear infinite;

  &.lg {
    @apply w-12 h-12 border-4;
  }

  &.md {
    @apply w-7 h-7 border-[3px];
  }

  &.sm {
    @apply w-[18px] h-[18px] border-[3px];
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
